export const GET_OPERATOR_DATA = 'operator/GET_OPERATOR_DATA';
export const GET_OPERATOR_DATA_SUCCESS = 'operator/GET_OPERATOR_DATA_SUCCESS';
export const GET_OPERATOR_DATA_FAIL = 'operator/GET_OPERATOR_DATA_FAIL';

export const GET_ALL_OPERATOR_DATA = 'operator/GET_ALL_OPERATOR_DATA';
export const GET_ALL_OPERATOR_DATA_SUCCESS = 'operator/GET_ALL_OPERATOR_DATA_SUCCESS';
export const GET_ALL_OPERATOR_DATA_FAIL = 'operator/GET_ALL_OPERATOR_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/operator.js